<template>
  <div class="filter-item">
    <v-btn  class="filter-item__remove-btn" v-if="filter.isCustomAttribute" icon elevation="0" x-small  @click="removeFilterItem">
      <v-icon color="primary">mdi-close-circle</v-icon>
    </v-btn>
    <div :class="`filter-item__label ${filter.type === 'slipsheet'? 'filter-item__label--short': ''} ${filter.isActive ? 'filter-item__label--active' : ''}`">
      <template v-if="filter.label">
        <span>{{ filter.label }}</span>
      </template>

      <template v-else>
        <lang :t="'FILTER-' + filter.name.toUpperCase()" />
      </template>
    </div>
    <div :class="`filter-item__content ${filter.type == 'slipsheet' ? 'filter-item__content-large' : ''}`">
      <!-- DEFAULT (Binary) -->
      <template v-if="filter.type == 'default'">
        <v-select
          :items="filter.options"
          v-model="filter.selection"
          :item-text="filter.itemText ? filter.itemText : 'displayName'"
          :item-value="filter.itemValue ? filter.itemValue : 'id'"
          class="filter-item__dropdown"
          flat
          dense
          hide-details
          single-line
          elevation="0"
          :loading="optionsLoading"
          @change="changeFilterOption"
        >
          <template v-slot:item="{ item }">
            <span class="filter-item--text">{{ item.displayName }}</span>
          </template>
          <template v-slot:selection="{ item, index }">
            <div x-small v-if="index <= 0" class="filter-item--text">
              <span>{{ item.displayName }}</span>
            </div>
            <span v-if="index === 1" style="padding: 0; margin: 0;"> (+{{ filter.selection.length - 1 }} others) </span>
          </template>
        </v-select>
      </template>

      <!-- TEXTBOX - INPUT -->
      <template v-else-if="filter.type== 'textbox'">
        <v-text-field
        v-model="filter.selection"
    ></v-text-field>
   
      </template>
     
      <!-- SINGLE DROPDOWN -->
      <template v-else-if="filter.type == 'dropdownSingle'">
        <v-select
          :items="options"
          v-model="filter.selection"
          :item-text="filter.itemText ? filter.itemText : 'name'"
          :item-value="filter.itemValue ? filter.itemValue : 'id'"
          class="filter-item__dropdown"
          flat
          dense
          hide-details
          single-line
          elevation="0"
          :loading="optionsLoading"
          @change="onSelectboxChange"
          @click="onSelectboxClick"
        >
          <template v-slot:item="{ item }">
            <span class="filter-item--text">{{ item[filter.itemText ? filter.itemText : 'name'] }}</span>
          </template>
          <template v-slot:selection="{ item, index }">
            <div x-small v-if="index <= 0" class="filter-item--text">
              <span>{{ item[filter.itemText ? filter.itemText : 'name'] }}</span>
            </div>
            <span v-if="index === 1" style="padding: 0; margin: 0;"> (+{{ filter.selection.length - 1 }} others) </span>
          </template>
        </v-select>
      </template>

      <!-- DATE PICKER -->
      <template v-else-if="filter.type == 'datePicker'">
        <div class="filter-item__datePicker">
          <v-menu v-model="datePickerOpen" :close-on-content-click="false" :nudge-left="40" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field clearable v-model="filter.selection" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>

            <v-date-picker
              :no-title="true"
              class="filter-item__dropdown"
              v-model="filter.selection"
              :locale="languageTag"
              @input="
                datePickerOpen = false;
                filter.isActive = true;
              "
            ></v-date-picker>
          </v-menu>
        </div>
      </template>

       <!-- DATE RANGE -->
       <template v-else-if="filter.type == 'dateRange'">
        <div class="filter-item__dateRange">
          <v-menu v-model="datePickerOpen" :close-on-content-click="false" nudge-left="170" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-textarea class="filter-item__textarea" height="30px"  :rows="filter.selection && filter.selection.length > 1? 2: 1" dense flat  no-resize
              clearable :value="filter.selection ? filter.selection.join('\r\n'): ''" readonly v-bind="attrs" v-on="on" @click:clear="clearDateRange"></v-textarea>
            </template>

            <v-date-picker
              :no-title="true"
              range
              class="filter-item__dropdown"
              v-model="rangeSelection"
              :locale="languageTag"
              color="#1b99a7"
              @change="(val) => {filter.selection = val; datePickerOpen=false}"
              @input="
                datePickerOpen = true;
              "
            ></v-date-picker>
          </v-menu>
        </div>
      </template>

      <!-- MULTIPLE DROPDOWN -->
      <template v-else-if="filter.type == 'dropdownMultiple'">
        <v-select
          :items="options"
          v-model="filter.selection"
          :multiple="true"
          
          flat
          class="filter-item__dropdown"
          dense
          hide-details
          single-line
          :item-text="filter.itemText ? filter.itemText : 'name'"
          :item-value="filter.itemValue ? filter.itemValue : 'id'"
          elevation="0"
          @keyup="optionsLoading = false"
          :loading="optionsLoading"
          @change="onSelectboxChange"
          @click="onSelectboxClick"
        >
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :ripple="false" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  <span class="filter-item--text">{{ item[filter.itemText ? filter.itemText : 'name'] }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item, index }">
            <div x-small v-if="index <= 0" class="filter-item--text">
              <span>{{ item[filter.itemText ? filter.itemText : 'name'] }}</span>
            </div>
            <span v-if="index === 1" style="padding: 0; margin: 0;"> (+{{ filter.selection.length - 1 }} others) </span>
          </template>
        </v-select>
      </template>

      <!-- MIN-MAX -->
      <template v-else-if="filter.type == 'minMax'">
        <div class="filter-item__min-max">
          <v-text-field dense hide-spin-buttons hide-details type="number" v-model="filter.selection.min" label="min" />
          <v-text-field dense hide-spin-buttons hide-details type="number" v-model="filter.selection.max" label="max" />
        </div>
      </template>

      <!-- SLIPSHEET (SEPCIAL) -->
      <template v-else-if="filter.type == 'slipsheet'" class="d-flex justify-center">
        <v-row dense no-gutters justify="space-between" class="ma-0">
          <v-col cols="5" class="d-flex justify-center  align-start flex-column">
            <v-btn
              v-for="option in filter.options1"
              :value="option.value"
              :class="`filter-item__slipsheet--btn ${isSlipsheetOptions1Active(option) ? 'filter-item__slipsheet--btn-active' : ''}`"
              @click="setSlipsheetOption1Active(option)"
              :key="option.value"
              x-small
            >
              {{ option.label }}
            </v-btn>
          </v-col>
          <v-col cols="7">
            <v-select
              :items="filter.options2"
              v-model="slipsheets.option"
              item-text="label"
              item-value="value"
              class="filter-item__dropdown"
              flat
              dense
              hide-details
              single-line
              elevation="0"
              :loading="optionsLoading"
              @change="onSelectSlipsheet"
              @click="onSelectboxClick"
            >
              <template v-slot:item="{ item }">
                <span class="filter-item--text">{{ item.label }}</span>
              </template>
              <template v-slot:selection="{ item, index }">
                <div x-small v-if="index <= 0" class="filter-item--text">
                  <span>{{ item.label }}</span>
                </div>
                <span v-if="index === 1" style="padding: 0; margin: 0;"> (+{{ filter.selection.length - 1 }} others) </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterItem",
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: [],
      dialog: false,
      slipsheets: {
        initSelectedOptions: [],
        options: [],
        option: undefined,
      },
      rangeSelection: [],
      selected: null,
      datePicker: null,
    };
  },
  watch: {
    "filter.selection": {
      handler(newValue) {
        if (this.filter.type !== "slipsheet") return;
        if (!Array.isArray(newValue)) return;
        if (newValue.length > 0) return; // skip because it was change internally, the selection can be only empty if it comes from FilterSelector
        this.slipsheets = Object.assign(this.slipsheets, {option: undefined, options: []});
      },
      deep: true,
    },
    "datePickerOpen":{
      handler(value){
        if(value) return;
        if(this.filter.selection == "" || this.filter.selection === null){
          this.setAsInactiveFilter();
        }else{
            this.setAsActiveFilter();
        }
      }
    }
  },
  created() {
    this.options = this.filter.options?.length ? this.filter.options : [];

    if (this.filter.selection && this.filter.selection.length > 0) this.loadOptions();
    this.prepareDefaultFilter();
    this.prepareSlipsheets();
  },
  mounted() {},
  methods: {
    isSlipsheetOptions1Active(option) {
      return this.slipsheets.options.includes(option.value);
    },
    clearDateRange(){
      this.rangeSelection = [];
      this.$emit('clearSelection');
    },
    setAsInactiveFilter(){
      this.$emit('inactive', true);
    },
    setAsActiveFilter(){
      this.$emit('active', true);
    },
    prepareSlipsheets() {
      if (this.filter.type !== "slipsheet") return;
      this.onSelectSlipsheet();
      this.slipsheets.initSelectedOptions = [...this.filter.selection];
    },
    prepareDefaultFilter() {
      if (this.filter.type !== "default") return;
      if (!this.filter.options || (this.filter.options && !this.filter.options.length)) return;
      const selected = this.filter.options.find((el) => el.isSelected);
      if (selected) {
        this.filter.selection = selected.id;
      }
    },
    onSelectSlipsheet() {
      let selection = [...this.slipsheets.options];
      if(this.slipsheets.option){
        selection = [...this.slipsheets.options, this.slipsheets.option];
      }
      this.filter.selection = [...selection];
      this.optionsLoading = false;
    },

    onSelectboxChange(val) {
      this.filter.selection = val;
    },

    onSelectboxClick(val) {
      this.filter.isActive = true;

      if (this.filter.isActive && (this.options == null || !this.options.length || this.options.length == 0)) {
        this.loadOptions();
      }
      this.loadOptions = false;
    },

    deactivateFilter() {
      this.toggleFilter(true);
    },

    setSlipsheetOption1Active(option) {
      const foundOption = this.slipsheets.options.find((el) => el === option.value);
      if (foundOption) {
        this.slipsheets.options = this.slipsheets.options.filter((el) => el !== option.value);
      } else {
        this.slipsheets.options.push(option.value);
      }

      this.onSelectSlipsheet();
    },

    toggleFilter(deactivate = false) {
      if (!deactivate) {
        this.filter.isActive = !this.filter.isActive;
      }

      // default filters
      if (this.filter.type == "default") {
        // if there was only one option, we automatically active it upon filter activation
        if (this.filter.options.length == 1) {
          this.filter.options[0].isSelected = true;
        }

        // deselect all filter options upon filter deactivation
        if (!this.filter.isActive) {
          this.filter.options.forEach((option) => (option.isSelected = false));
        }
      }

      // date filter
      else if (this.filter.type == "datePicker") {
        // category filter
      } else if (this.filter.type == "category" || this.filter.type == "dropdownSingle") {
        if (this.filter.isActive && (this.options == null || !this.options.length || this.options.length == 0)) {
          this.loadOptions();
        } else if (!this.filter.isActive) {
          this.selected = null;
          this.filter.options = null;
        }
      }
    },

    changeFilterOption(optionId) {
      const foundOption = this.filter.options.find((el) => el.id === optionId);
      this.filter.options = this.filter.options.map((option) => {
        if (foundOption && foundOption.id === option.id) {
          return Object.assign(option, { isSelected: !foundOption.isSelected });
        }
        return Object.assign(option, { isSelected: false });
      });
    },

    changeFilterSelector() {
      if (this.options == null) {
        this.loadOptions();
      } else {
        this.filter.isActive = true;
        return false;
      }
    },

    removeFilterItem(){
      this.$emit('removeFilterItem');
    },

    loadOptions() {
      if (typeof this.filter.selectOptions != "undefined" && this.filter.selectOptions.length > 0) {
        this.options = this.filter.selectOptions;
        this.filter.isActive = true;
      } else {
        if (this.options.length) {
          return;
        }
        this.optionsLoading = true;

        this.axios.get(this.$config.api + this.filter.api).then((res) => {
          if (this.filter.apiKey) {
            this.options = res.data[this.filter.apiKey];
          } else {
            this.options = res.data;
          }

          if (this.filter.filterAfterFetch) {
            this.options = res.data.filter((item) => this.filter.filterAfterFetch(item));
          }

          if (this.filter.additionalFilterOption) {
            this.options.unshift(this.filter.additionalFilterOption);
          }

          this.filter.options = this.options;
          this.optionsLoading = false;
          setTimeout(() => {
            this.optionsLoading = false;
            this.filter.isActive = false;
          }, 100);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-item {
  display: flex;
  flex: 1;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  text-transform: lowercase;
  padding: 0.5em 0.5em;
  background: #fff;
  margin: 0.05em 0.1em;
  border: 1px solid #cdcdcd;
  color: #5e5e5e;
  position: relative;
  &:first-letter {
    text-transform: capitalize;
  }

  &__remove-btn{
    position: absolute;
    right: -8px;
    top:-4px;
    z-index: 33;
  }

  &--text {
    color: #5e5e5e;
    text-transform: lowercase;
    display: block;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  &__label {
    flex: 0 1 110px;
    &--short{
      flex: 0 1 70px;
    }
    font-family: Arial, sans-serif;
    font-weight: 700;
    font-size: 9px;
    word-break: break-all;
    text-transform: lowercase;
    line-height: 10.35px;
    letter-spacing: 0.8px;
    color: #5e5e5e;
    &:first-letter {
      text-transform: capitalize;
    }

    & span{
        display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;  
    }

    &--active {
      color: #1b99a7;
    }
  }

  &__content {
    flex: 1;
    &-large {
      display: flex;
      flex: 3;
      align-items: center;
      justify-content: center;
    }
  }

  &__slipsheet {
    &--btn {
      display: flex;
      box-shadow: none;
      background: transparent !important;
      font-family: Arial, sans-serif;
      font-weight: 400;
      font-size: 9px!important;
      height: auto !important;
      line-height: 10.35px;
      padding: 0.2em;
      letter-spacing: 0.8px;
      color: #5e5e5e;
      &-active {
        color: #1b99a7;
      }
      &::v-deep .v-btn__content{
        font-size: 9px!important;
      }
    }
  }

  &__dropdown,
  &__dropdown::v-deep .v-select__selections,
  &__dropdown::v-deep .v-label,
  &__min-max::v-deep .v-label,
  &__datapicker,
  &__datePicker::v-deep .v-label, 
  &__textarea {
    font-weight: normal !important;
    font-family: Arial, sans-serif !important;
    text-transform: lowercase !important;
    font-size: 9px;
    line-height: 10.35px;
    letter-spacing: 0.8px;
    color: #5e5e5e;
    &:first-letter {
      text-transform: capitalize;
    }
  }

  &__textarea::v-deep  .v-input__slot{
    margin-bottom: -6px!important;
  }

  &__textarea::v-deep .v-input__append-inner{
    margin-top: 10px!important;
  }



  &__min-max::v-deep .v-label {
    top: 8px;
    &--active{
      top: 12px!important;
    }
  }

  &__dropdown::v-deep .v-label{
    position: relative!important;
  }

  &__datePicker::v-deep .v-text-field {
    padding-top: 0px !important;
    margin: 0px;
    margin-bottom: 0px;
    max-height: auto !important;
  }

  &__datePicker::v-deep .v-input__slot {
    margin-bottom: -24px;
  }

  &__datePicker::v-deep .v-text-field input {
    padding-bottom: 0px !important;
    padding-top: 0px !important;
    max-height: auto !important;

    font-weight: normal !important;
    font-family: Arial, sans-serif !important;
    text-transform: capitalize !important;
    font-size: 9px;
    letter-spacing: 0.8px;
  }

  &__min-max {
    display: flex;

    & > * {
      flex: 1;
      padding: 0.15em 0.25em 0.15em 0;
    }
  }
}

::v-deep .v-textarea textarea{
    line-height: 14px!important;
    min-height: 10px!important;
    align-items: center;
    color: #5e5e5e;
  }
</style>
